import {Button} from "@/components/shadcn/button.tsx";
import {Languages} from "lucide-react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {TranslationsDialog} from "@/components/common/translations/TranslationsDialog.tsx";
import type {PlannedLanguages} from "@/components/common/translations/types.ts";

interface TranslateButtonProps {
  dialogTitle?: string
  value: Record<string, string>
  onChange: (translations: Record<string, string>) => void
  plannedLanguages?: PlannedLanguages
  onPlannedChange?: (planned: PlannedLanguages) => void
  autoTranslateAll?: boolean
}

export function TranslateButton({
                                  dialogTitle,
                                  value,
                                  onChange,
                                  plannedLanguages,
                                  onPlannedChange,
                                  autoTranslateAll,
                                }: TranslateButtonProps) {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title={t('translations.editTranslations')}
        onClick={() => setOpen(true)}
      >
        <Languages className="text-primary" />
      </Button>
      <TranslationsDialog
        open={open}
        onOpenChange={setOpen}
        title={dialogTitle}
        value={value}
        onApply={onChange}
        plannedLanguages={plannedLanguages}
        onPlannedChange={onPlannedChange}
        autoTranslateAll={autoTranslateAll}
      />
    </>
  )
}
